import React from "react";
import { Instagram, Facebook, MapPin, Phone } from "lucide-react";
import { BRAND } from "../lib/i18n";
import { useLang } from "../contexts/LanguageContext";
import { WhatsAppIcon, TikTokIcon } from "./Header";

const Footer = () => {
  const { t } = useLang();
  return (
    <footer
      className="relative border-t border-white/5 pt-20 pb-10 mt-10 overflow-hidden"
      data-testid="site-footer"
    >
      <div
        className="absolute inset-x-0 top-0 h-px"
        style={{
          background:
            "linear-gradient(90deg, transparent, rgba(212,175,55,0.6), transparent)",
        }}
      />
      <div className="container-hd">
        <div className="grid md:grid-cols-[1.5fr,1fr,1fr] gap-10 mb-14">

          <div>
            <div className="flex items-center gap-3 mb-5">
              <img
                src={BRAND.logoUrl}
                alt="Hetlav Detailing Wien Logo – Autoaufbereitung & Fahrzeugaufbereitung"
                width="48"
                height="48"
                loading="lazy"
                decoding="async"
                className="w-12 h-12 rounded-full object-cover border border-white/10"
              />
              <div>
                <div className="font-display font-bold text-white text-lg tracking-wide">
                  HETLAV
                </div>
                <div className="font-body text-[10px] tracking-[0.3em] text-[color:var(--hd-gold)] uppercase">
                  Detailing
                </div>
              </div>
            </div>
            <p className="text-white/50 text-sm max-w-md leading-relaxed">
              {t.footer.tagline} Mobile Auto & Möbel Tiefenreinigung in Wien und
              Umgebung.
            </p>
            <div className="flex items-center gap-3 mt-6">
              <a
                href={BRAND.instagram}
                target="_blank"
                rel="noreferrer"
                className="w-10 h-10 rounded-full border border-white/10 flex items-center justify-center text-white/60 hover:text-[color:var(--hd-gold)] hover:border-[color:var(--hd-gold)]/40 transition-all"
                data-testid="footer-instagram"
                aria-label="Instagram"
              >
                <Instagram size={16} />
              </a>
              <a
                href={BRAND.facebook}
                target="_blank"
                rel="noreferrer"
                className="w-10 h-10 rounded-full border border-white/10 flex items-center justify-center text-white/60 hover:text-[color:var(--hd-gold)] hover:border-[color:var(--hd-gold)]/40 transition-all"
                data-testid="footer-facebook"
                aria-label="Facebook"
              >
                <Facebook size={16} />
              </a>
              <a
                href={BRAND.whatsappUrl}
                target="_blank"
                rel="noreferrer"
                className="w-10 h-10 rounded-full border border-white/10 flex items-center justify-center text-white/60 hover:text-[color:var(--hd-gold)] hover:border-[color:var(--hd-gold)]/40 transition-all"
                data-testid="footer-whatsapp"
                aria-label="WhatsApp"
              >
                <WhatsAppIcon width={16} height={16} />
              </a>
              <a
                href={BRAND.tiktok}
                target="_blank"
                rel="noreferrer"
                className="w-10 h-10 rounded-full border border-white/10 flex items-center justify-center text-white/60 hover:text-[color:var(--hd-gold)] hover:border-[color:var(--hd-gold)]/40 transition-all"
                data-testid="footer-tiktok"
                aria-label="TikTok"
              >
                <TikTokIcon width={16} height={16} />
              </a>
            </div>
          </div>

          <div>
            <div className="font-display text-sm uppercase tracking-wider text-[color:var(--hd-gold)] mb-5">
              {t.footer.contact}
            </div>
            <ul className="space-y-3 text-sm text-white/60">
              <li className="flex items-center gap-2">
                <Phone size={14} className="text-[color:var(--hd-gold)]" />
                <a
                  href={`tel:${BRAND.phone.replace(/\s+/g, "")}`}
                  className="hover:text-white transition-colors"
                >
                  {BRAND.phone}
                </a>
              </li>
              <li className="flex items-center gap-2">
                <MapPin size={14} className="text-[color:var(--hd-gold)]" />
                <span>{BRAND.location}</span>
              </li>
            </ul>
          </div>

          <div>
            <div className="font-display text-sm uppercase tracking-wider text-[color:var(--hd-gold)] mb-5">
              {t.nav.services}
            </div>
            <ul className="space-y-2 text-sm text-white/60">
              <li>
                <a href="#services" className="hover:text-white transition-colors">
                  Auto Innenreinigung
                </a>
              </li>
              <li>
                <a href="#services" className="hover:text-white transition-colors">
                  Sofa Reinigung
                </a>
              </li>
              <li>
                <a href="#services" className="hover:text-white transition-colors">
                  Matratzen
                </a>
              </li>
              <li>
                <a href="#gallery" className="hover:text-white transition-colors">
                  {t.nav.gallery}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="flex flex-col md:flex-row items-center justify-between gap-4 pt-8 border-t border-white/5">
          <div className="text-white/40 text-xs">
            © {new Date().getFullYear()} Hetlav Detailing. {t.footer.rights}
          </div>
          <div className="font-serif italic text-white/30 text-xs">
            Crafted with care — Wien 2026
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
